export default function isEventComplete(event) {
  return typeof event?.data?.title === 'string' && event.data.title.trim().length > 0;
}